import Dropdown from "tailwindcss-stimulus-components/src/dropdown";

// Extends the library Dropdown to sync aria-expanded / aria-controls on the
// toggle button whenever the open state changes. Works with existing markup
// that uses data-action="dropdown#toggle" — no template changes required.
export default class extends Dropdown {
  connect() {
    super.connect();
    this.#syncAria();
  }

  openValueChanged() {
    super.openValueChanged();
    this.#syncAria();
  }

  #syncAria() {
    // Ensure the menu panel has a stable id so the button can reference it.
    if (this.hasMenuTarget && !this.menuTarget.id) {
      this.menuTarget.id = `dd-menu-${Math.random().toString(36).slice(2, 9)}`;
    }

    // The library supports an optional data-dropdown-target="button"; fall
    // back to querying for the toggle action if the target isn't declared.
    const btn = this.hasButtonTarget
      ? this.buttonTarget
      : this.element.querySelector('[data-action*="dropdown#toggle"]');

    if (!btn) return;

    btn.setAttribute("aria-expanded", String(this.openValue));
    if (this.hasMenuTarget) {
      btn.setAttribute("aria-controls", this.menuTarget.id);
    }
  }
}
